const _ = require('lodash')
export default {
  updateBoats (state, data) {
    state.boats = _.concat(state.boats.filter((b) => b.clientId !== data.clientId), data.boats)
  },
  deleteBoat (state, boatId) {
    state.boats = state.boats.filter((b) => b.id !== boatId)
  }
}
